export default __webpack_public_path__ + "static/media/message.85ec8f4d.svg";